import { isCertAccess } from '../../../shared/DOM/isCertAccess.js';
import { setElementVisible } from '../../../shared/DOM/setElementVisible.js';
import { getIntroAlertObject } from './getIntroAlertObject.js';
import { getGroupOptionsFactoryFn } from '../api/getGroupOptionsFactoryFn.js';

/**
 * En este módulo incluímos los métodos relacionadoa con el view del LoginFrom
 *
 * @returns Login View json
 */

export function getLoginView(eForm) {
  const html = document.querySelector('html');
  const showDomain = !html?.hasAttribute('domain-concentration');
  const showCertAccess = isCertAccess();

  const formProperties = [
    {
      name: 'loginAlert',
      type: 'alert',
      metadata: {
        closable: false,
        style: 'danger',
      },
      cols: 8,
    },
    getInputUser(),
    getInputPass(),
    {
      model: 'group',
      name: 'selectGroup',
      title: edicom.locale.translate('global.selectGroup'),
      type: 'select',
      required: true,
      metadata: {
        icon: 'users',
        cache: false,
        autocomplete: false,
        getOptionsFn: getGroupOptionsFactoryFn(eForm),
      },
      cols: 8,
    },
    {
      name: 'btnSubmit',
      type: 'button',
      title: edicom.locale.translate('global.acceder'),
      metadata: {
        icon: 'right-to-bracket',
        style: 'primary fill',
      },
      cols: 8,
    },
  ];

  // Domain visible manual > para que funcione necesita un objeto intermedio data.domain
  if (showDomain) {
    formProperties.splice(3, 0, getInputDomain());
  }

  if (showCertAccess) {
    formProperties.push({
      name: 'btnCertAccess',
      type: 'button',
      title: edicom.locale.translate('login.certificate'),
      metadata: {
        icon: 'certificate',
        style: 'primary stroked fill',
      },
      cols: 8,
    });
  }

  return {
    properties: [
      {
        type: 'object',
        name: 'index.html',
        cols: 4,
        properties: formProperties,
      },
      getIntroAlertLogin(html),
    ],
  };
}

export function getInputUser() {
  return {
    model: 'user',
    name: 'inputUser',
    title: edicom.locale.translate('login.user'),
    placeholder: edicom.locale.translate('login.user'),
    type: 'string',
    required: true,
    metadata: {
      icon: 'user',
    },
    cols: 8,
  };
}

export function getInputPass() {
  return {
    model: 'password',
    name: 'inputPass',
    title: edicom.locale.translate('login.password'),
    placeholder: edicom.locale.translate('login.password'),
    type: 'password',
    required: true,
    cols: 8,
  };
}

export function getInputDomain() {
  return {
    model: 'domain',
    name: 'inputDomain',
    title: edicom.locale.translate('login.domain'),
    placeholder: edicom.locale.translate('login.domain'),
    type: 'string',
    required: true,
    metadata: {
      icon: 'globe',
    },
    cols: 8,
  };
}

export function getIntroAlertLogin(html) {
  const isPortal = html?.hasAttribute('portal');
  const isSignup = html?.hasAttribute('signup');

  const keyIntro1 = isPortal ? 'global.introPortal1' : 'global.intro1';
  const keyIntro2 = isPortal ? 'global.introPortal2' : 'global.intro2';

  return getIntroAlertObject(keyIntro1, !isPortal || isSignup ? keyIntro2 : null);
}

export function getLoginViewAlert() {
  return document.querySelector('ewc-alert[view-name="loginAlert"]');
}

export function getLoginViewBtnSubmit() {
  return document.querySelector('ewc-button[view-name="btnSubmit"]');
}

export function getLoginViewInputDomain() {
  return document.querySelector('ewc-string[view-name="inputDomain"]');
}

export function getLoginViewSelectGroup() {
  return document.querySelector('ewc-select[view-name="selectGroup"]');
}

export function hideLoginError() {
  document.querySelector('ewc-form')?.state?.hide?.('loginAlert');
}

export async function showLoginError(message) {
  document.querySelector('ewc-form')?.state?.show?.('loginAlert');
  const eAlert = getLoginViewAlert();
  eAlert.innerHTML = edicom.locale.translate(message);
}

export function setLoginSelectGroupVisible(visible) {
  const eSelect = getLoginViewSelectGroup();
  eSelect && setElementVisible(eSelect, visible);
}
